export const identityProviders = {
  okta: 'okta',
  azureAd: 'azure_ad',
  dustinPunchout: 'dustin_punchout',
}
